import { Axios } from "@workspace/common";
import { JOB_URL } from "@workspace/common/src/config";

import { BASE_INTERVIEWS } from "./url_helper";

const { APIClient } = Axios;

const api = new APIClient();

//Get counts for status of interviews
export const getCounts = (countPayload) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/get-counts`, countPayload);

//Get interview Data
export const getListing = (requestPayload) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/listing`, requestPayload);

//Delete Interviews
export const deleteInterviews = (id) =>
  api.delete(`${JOB_URL}${BASE_INTERVIEWS}`, { data: id });

//Get daily interview Data
export const getDailyInterviews = (data) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/upcoming-interview`, data);

//Create Interview Custom View
export const createInterviewCustomView = (data) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/save/customfields`, data);

//Get all Interview Custom View
export const getAllInterviewCustomView = () =>
  api.get(`${JOB_URL}${BASE_INTERVIEWS}/customView/all`);

//Update isSelected of Interview Custom View
export const selectInterviewCustomView = (id) =>
  api.put(`${JOB_URL}${BASE_INTERVIEWS}/customView/update/${id}`);

//Delete Interview Custom View
export const deleteInterviewCustomView = (id) =>
  api.delete(`${JOB_URL}${BASE_INTERVIEWS}/customView/delete/${id}`);

//Get Custom View by id
export const getInterviewCustomViewById = (id) =>
  api.get(`${JOB_URL}${BASE_INTERVIEWS}/customView/${id}`);

//Edit Custom View by id
export const editInterviewCustomViewById = (id, data) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/customView/edit/${id}`, data);
//Unselect all custom view
export const unselectAllCustomView = () =>
  api.put(`${JOB_URL}${BASE_INTERVIEWS}/customView/unselect-all`);

//Unselect all custom view
export const createInterview = (data, config) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}`, data, config);

export const addInterviewLogs = (formData) =>
  api.put(`${JOB_URL}${BASE_INTERVIEWS}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const cancelInterview = (formData) =>
  api.put(`${JOB_URL}${BASE_INTERVIEWS}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const completeInterview = (interviewId, data) =>
  api.put(`${JOB_URL}${BASE_INTERVIEWS}/${interviewId}`, data);

export const fetchJobCandidates = (data) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/jobTimelines`, data);

export const rescheduleInterview = (formData) =>
  api.put(`${JOB_URL}${BASE_INTERVIEWS}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const fetchJobCandidate = (data) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/get-jobTimelineById`, data);

export const uploadInterviewAttachment = (data, config) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/upload`, data, config);

export const fetchInterviewByMultiIds = (data) =>
  api.create(`${JOB_URL}${BASE_INTERVIEWS}/fetch/entityByIds`, data);
